import React, { useCallback } from 'react';
import c from 'classnames';
import { Node } from 'prosemirror-model';

import { Close } from '@lyearn/icons';
import { Box, ClickAwayListener, DeprecatedIconButton, Typography } from '@lyearn/ui';

import { setPluginMeta } from '../../utils';
import { iconButton, menuBox } from './style';
import { AdvancedMenuProps } from './types';
import { AdvancedMenuPluginKey, hideAdvancedMenu } from './utils';

export const AdvancedMenuComponent: React.FC<AdvancedMenuProps> = (props) => {
  let { open, selectionNode, view, advancedMenuItem, pos } = props;

  const onClose = useCallback(() => {
    if (!view) {
      return;
    }
    const prevState = AdvancedMenuPluginKey.getState(view.state);
    setPluginMeta(view!, AdvancedMenuPluginKey, { ...prevState, open: false });
  }, [view]);

  const onClickAway = useCallback(() => {
    if (view) {
      hideAdvancedMenu(view);
    }
  }, [view]);

  if (!open || !view || !selectionNode || !Number.isInteger(pos)) {
    return null;
  }

  return (
    //adding mouseEvent="onMouseUp" to avoid calling onClickAway when using Select component in form
    //ref: https://github.com/mui-org/material-ui/issues/12034
    <ClickAwayListener mouseEvent="onMouseUp" onClickAway={onClickAway}>
      <Box
        className={c(
          'absolute bottom-0 z-20 border-divider bg-bg-primary p-24 start-0 border-e',
          menuBox,
        )}>
        <Box className="flex justify-between border-b border-border pb-16">
          <Typography variant="heading-xs">{advancedMenuItem.title}</Typography>
          <DeprecatedIconButton className={c('p-0', iconButton)} variant="ghost" onClick={onClose}>
            <Close className="w-24 cursor-pointer fill-current text-icon-placeholder" />
          </DeprecatedIconButton>
        </Box>
        {advancedMenuItem.components.map((value) => {
          if (!value.isEnabled(selectionNode as Node)) {
            return null;
          }
          return (
            <Box key={value.name} className="border-b border-border py-20">
              <value.component currentSelectionNode={selectionNode!} pos={pos!} view={view!} />
            </Box>
          );
        })}
      </Box>
    </ClickAwayListener>
  );
};
